import type { ReactNode } from "react";

interface Props<T extends { id: string }> {
  actions: ReadonlyArray<T>;
  renderButton: (action: T, index: number) => ReactNode;
}

export default function DetailModalFooterActions<T extends { id: string }>({ actions, renderButton }: Props<T>) {
  if (actions.length === 3) {
    const [primary, ...secondary] = actions;
    return (
      <div className="flex flex-col gap-3">
        {renderButton(primary, 0)}
        <div className="grid grid-cols-2 gap-3">
          {secondary.map(function renderSecondaryButton(action, index) {
            return renderButton(action, index + 1);
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {actions.map(function renderFlatButton(action, index) {
        return renderButton(action, index);
      })}
    </div>
  );
}
